import { useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import buildHubUrl from "./buildHubUrl";
import CreateConnection from "./HubMatrix";
import { connectToHubUser } from "src/redux/slices/hub";
import { getActiveAddOns } from "src/redux/slices/addOns";

// 2026-08-27 · Hook global — escucha `add-on-grants-changed/{restauranteId}`
// del UserHub. Backend lo emite tras `SetGrantsForUser` (regalo admin de
// add-on). Sin este hook, el user con sesión abierta seguía viendo el
// nav y los AddOnGate con "PRO · Contrátalo" hasta hacer un F5 completo
// porque el cache `activeAddOnsLoaded=true` bloqueaba el refetch.
//
// Al recibir: force-refetch de activeAddOns + snackbar informativo.
export default function useAddOnGrantsHub() {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { user } = useSelector((s) => s.authJwt);
  const seenRef = useRef(new Set());

  const restauranteId = user?.id;

  useEffect(() => {
    if (!restauranteId) return undefined;

    // 2026-08-27 · Force refetch al MONTAR (además del listener del
    // push). Cubre el escenario "admin cambió los grants antes de que
    // yo entrara / reconectara": mi conexión SignalR llega tarde al
    // grupo y no recibe el push retro, pero al montar hago un pull
    // fresh contra /addOn/ActiveIds y la UI queda consistente. Sin
    // esto el user tenía que recargar varias veces hasta que un F5
    // coincidía con el momento en que el slice ya no tenía cache.
    dispatch(getActiveAddOns({ force: true }));

    const handler = async (payload) => {
      const sig = `${payload?.timestamp || Date.now()}`;
      if (seenRef.current.has(sig)) return;
      seenRef.current.add(sig);
      if (seenRef.current.size > 50) {
        const first = seenRef.current.values().next().value;
        seenRef.current.delete(first);
      }

      try {
        await dispatch(getActiveAddOns({ force: true }));
      } catch { /* silent — al próximo F5 llegará bien */ }

      enqueueSnackbar(
        "Tu suscripción ha cambiado. Los extras se han actualizado.",
        { variant: "info", autoHideDuration: 4000 },
      );
    };

    const cleanup = CreateConnection(
      buildHubUrl("/hub/userhub", { restauranteId }),
      [{ id: `add-on-grants-changed/${restauranteId}`, operator: handler }],
      dispatch,
      connectToHubUser,
      "user",
    );

    return cleanup;
  }, [restauranteId, dispatch, enqueueSnackbar]);
}
